<template>
    <Header class="zc-header">
        <div class="logo">订单管理系统</div>
        <div class="navs">
            <div class="rx-breadcrumb">
                <Breadcrumb>
                    <BreadcrumbItem class="text-333"><Icon type="md-options"></Icon> {{$store.state.parentRouterName}}</BreadcrumbItem>
                    <BreadcrumbItem>{{$route.meta.title}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="nav">
                <Poptip content="content" trigger="hover" placement="bottom-end">
                    <a href="javascript:void(0)">
                        <Icon type="ios-contact" size="18"/>
                        <span>{{ $store.state.userinfo.realName }} ( {{$store.state.userinfo.sex}} )</span>
                        <Icon type="ios-arrow-down" size="18"></Icon>
                    </a>
                    <div class="em-tip-tit" slot="title">
                        <div class="info">
                            <div class="name">{{ $store.state.userinfo.username }}</div>
                            <div class="position">&nbsp;{{ $store.state.userinfo.groupName }}</div>
                        </div>
                        <div class="avatar"><Icon type="ios-person-outline" size="30"/></div>
                    </div>
                    <div class="em-tip-content" slot="content">
                        <div class="line">
                            <Icon type="ios-medkit-outline" size="18" class="line-icon"/>
                            <span>账号安全</span>
                        </div>
                        <Divider class="em-divider"/>
                        <div class="logout" @click="loginOut">退出</div>
                    </div>
                </Poptip>
            </div>
        </div>
    </Header>
</template>

<script>
export default {
    name: 'Headers',
    components: {

    },
    data () {
        return {

        }
    },
    mounted(){
    },
    methods:{
        loginOut() {
            let that = this;
            this.$Modal.confirm({
                title: '退出',
                content: '您确定要退出吗?',
                onOk: () => {
                    that.$axios.get('/admin/login/logout')
                        .then(function (e) {
                            if(e.code == 0) {
                                that.$Message.success({ background: true,duration:3, content: e.msg});
                                that.$store.commit('SET_TOKEN' , '');
                                that.$store.commit('SET_USERINFO' , '');
                                that.$store.commit('SET_OPEN_NAMES' , 1);
                                that.$store.commit('SET_ACTIVE_NAMES' , 1);
                                that.$store.commit('SET_AUTH' , '');
                                that.$store.commit('SET_ROUTERS' , []);
                                that.$router.push({ path: '/login' })
                            }else{
                                that.$Message.error({ background: true,duration:3, content: e.data});
                            }
                        })
                        .catch(function (e) {
                            that.$Message.error({ background: true,duration:3, content: '退出失败'});
                        });
                },
                onCancel: () => {}
            });
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/public/Headers.vue